const nameSpace = 'dashboard'

export const actions = {
  SEARCH: `${nameSpace}/SEARCH`,
  UPDATE_SORT_OPTIONS: `${nameSpace}/UPDATE_SORT_OPTIONS`,
  UPDATE_SERVE_STATUS_FILTER: `${nameSpace}/UPDATE_SERVE_STATUS_FILTER`,
  UPDATE_KEYWORD_FILTER: `${nameSpace}/UPDATE_KEYWORD_FILTER`,
  UPDATE_PAGE: `${nameSpace}/UPDATE_PAGE`,
}

export const getters = {
  searchResult: `${nameSpace}/searchResult`,
  loading: `${nameSpace}/loading`,
  sortOptions: `${nameSpace}/sortOptions`,
  filter: `${nameSpace}/filter`,
  page: `${nameSpace}/page`,
}
